import { round } from '@aninix-inc/model/legacy'

interface IPayload {
  milliseconds: number
}
interface IOutput {
  seconds: number
}
export function convertMillisecondsToSeconds({
  milliseconds,
}: IPayload): IOutput {
  return {
    seconds: round(milliseconds / 1000, { fixed: 4 }),
  }
}
